/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useState } from 'react';
import { useSMGetPageContent } from '../machines/pageContent';
import { StateOSD } from '@vlinder-web/state-osd-v2-widget-react';
import { Header, UsersListComp } from '../components';
import { TweetyModal } from '@vlinder-web/tweety-modal-widget-react';

import { DistillerDetailListPageService } from '../services';
import { VApplication } from '@/application';
import { NewCampaignPageService } from '@pages/NewCampaign/services';
import { Paginate } from '@vlinder-web/paginate-widget-react';

const getSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync(
    'services.DistillerDetailListPageService'
  ) as DistillerDetailListPageService;
};

const getCreateSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync(
    'services.NewCampaignPageService'
  ) as NewCampaignPageService;
};

export const ContainerComm = (props: any) => {
  const staticPageContentConfig = getSrv()?.getStaticPageContent();
  const createCampaignStaticPageContentConfig =
    getCreateSrv()?.getStaticPageContent();
  const [modal, setModal] = useState({
    show: false,
    type: '',
    modalData: {},
  });
  const [template, setTemplate] = useState('html');
  const { campaignListSend, campaignListState } = useSMGetPageContent({});
  const [refreshPagination, setRefreshPagination] = useState(new Date());

  const onRefresh = () => {
    campaignListSend('TRIGGER_REFRESH', {});
  };

  console.log('campaignListState', campaignListState);

  const _onEditClick = (data: any) => {
    console.log('_onTogglePress data', data);
    setModal({
      show: true,
      type: 'edit',
      modalData: {},
    });
  };

  const _renderModal = () => {
    const formFields =
      createCampaignStaticPageContentConfig?.createCampaign?.templateForm.find(
        (item: any) => item?.type === template
      );
    console.log('modal', modal, 'formFields', formFields);
    if (modal.show && modal.type === 'edit') {
      return (
        <TweetyModal
          show={true}
          size={'xl'}
          scrollable={false}
          backdrop={'static'}
          submitButtonTitle={'Update'}
          //onSubmit={onUpdateProfile}
          onHide={() =>
            setModal({
              show: false,
              type: '',
              modalData: {},
            })
          }
          title={'Update Campaign'}
          tweetyWidgetProps={{
            fields: formFields?.form,
            layout: formFields?.layout,
            validatorConfig: formFields?.validatorConfig,
            initialData: modal.modalData,
          }}
        />
      );
    }
  };

  const _renderPage = () => {
    if (campaignListState?.matches('RENDER_PAGE')) {
      console.log(
        'campaignListState',
        campaignListState?.event?.data?.value?.isEmpty
      );
      return (
        <>
          {campaignListState?.event?.data?.value?.isEmpty ? (
            <StateOSD
              {...(staticPageContentConfig?.loading?.usersEmpty || {})}
            />
          ) : (
            <UsersListComp
              {...campaignListState?.event?.data?.value}
              onEditClick={_onEditClick}
              onViewClick={props?.onViewClick}
            />
          )}
        </>
      );
    }
    if (campaignListState?.matches('GET_PAGE_CONTENT')) {
      return (
        <StateOSD
          {...(staticPageContentConfig?.loading?.overViewLoading || {})}
        />
      );
    }
    return null;
  };

  const _renderHeader = () => {
    if (staticPageContentConfig?.header) {
      return (
        <>
          <Header
            {...(staticPageContentConfig?.header || {})}
            onRefreshClick={onRefresh}
          />
        </>
      );
    }
    return null;
  };

  const onPaginationChange = (event: any) => {
    campaignListSend('TRIGGER_REFRESH', {
      offset: event?.selected * 10,
      size: 10,
    });
  };

  const _renderPagination = () => {
    return (
      <Paginate
        {...(campaignListState?.event?.data?.value || {})}
        onPageChange={onPaginationChange}
        key={refreshPagination}
        totalItems={campaignListState?.event?.data?.value?.ultUsers?.length}
      />
    );
  };

  return (
    <>
      {_renderHeader()}
      {_renderPage()}
      {_renderModal()}
      {_renderPagination()}
    </>
  );
};
